import type { Line } from '@chatapp-inbox/shared';

const plural = (n: number, one: string, many: string): string => (n === 1 ? one : many);

/** "2 números encontrados." (o que salvar a conexão ou procurar de novo achou, ligados ou não). */
export function foundSentence(count: number): string {
  if (count === 0) return 'Nenhum número encontrado.';
  return `${count} ${plural(count, 'número encontrado', 'números encontrados')}.`;
}

/**
 * Resultado de "Atualizar números", dito em uma frase para o leitor de tela: quantos há e o que
 * mudou em relação ao que a tela mostrava (novos entram ligados; os que o serviço deixou de listar
 * ficam desligados, não são apagados).
 */
export function describeRefresh(before: readonly Line[], after: readonly Line[]): string {
  const known = new Map(before.map((line) => [line.id, line]));
  const added = after.filter((line) => !known.has(line.id)).length;
  const turnedOff = after.filter((line) => !line.enabled && known.get(line.id)?.enabled).length;
  const parts = [`Lista atualizada. ${foundSentence(after.length)}`];
  if (added > 0) parts.push(`${added} ${plural(added, 'novo', 'novos')}.`);
  if (turnedOff > 0) {
    parts.push(
      plural(
        turnedOff,
        '1 foi desligado porque o serviço deixou de listá-lo.',
        `${turnedOff} foram desligados porque o serviço deixou de listá-los.`,
      ),
    );
  }
  return parts.join(' ');
}

/** O prazo para responder com texto livre neste número ("Janela de resposta de 24 h"). */
export const replyWindowText = (hours: number): string => `Janela de resposta de ${hours} h`;
